// extracted by mini-css-extract-plugin
export default {"root":"_1txEJ","animator":"_31rKI","notification-link":"_3S5nq","notificationLink":"_3S5nq"};